import {Injectable} from '@angular/core';
import {ApiService, ApiResponse} from './api/api.service';
import {Workorder} from '../classes/workorder';
import {User} from '../classes/user';
import {Utils} from '../utils.class';
import {TtmImage} from '../classes/ttmimage';

@Injectable({
    providedIn: 'root'
})
export class WorkorderService {

    constructor(private apiService: ApiService) {

    }

    getWorkorder(id: number) {
        return this.apiService.getCall$<Workorder>(`workorders/${id}`, null, true);
    }

    getDrawingFile(drawingId: number) {
        return this.apiService.getCall$<Workorder>(`workorders/drawing-file/${drawingId}`);
    }

    getPlannedWorkorders(params: { userId?: any, date?: any, search?: any }) {
        return this.apiService.getCall$<Workorder[]>(`workorders/planned`, Utils.removeEmptyProps(params));
    }

    getAllWorkorders(params: { userId?: any, date?: any, search?: any }) {
        return this.apiService.getCall$<Workorder[]>(`workorders`, Utils.removeEmptyProps(params));
    }

    importAttachments(workorderId: number) {
        return this.apiService.postCall$<User[]>(`workorders/import-attachments`, {workorderId});
    }

    saveTtmsToWorkorder(workorderId: number, ttmIds: number[]) {
        return this.apiService.postCall$<number[]>(`workorders/ttms`, {
            workorderId, ttmIds
        });
    }

    getWorkorderImages(params?: {
        workorderId?: number,
        ttmTypeKey?: string[],
        ttmStatusKey?: string[],
        userId?: number,
        imageStatusKey?: string[],
        dateFrom?: string,
        dateTo?: string
    }) {
        return this.apiService.getCall$<any>(`workorder-images`, Utils.removeEmptyProps(params || {}));
    }
}
